require('../../../scss/modules/effects.scss');
import rwxAnimatedBorders from 'roseworx/js/effects/rwxAnimatedBorders';
import rwxSlide from 'roseworx/js/effects/rwxSlide';
import rwxFade from 'roseworx/js/effects/rwxFade';


window.addEventListener('load', ()=>{
	document.getElementById('slideDown-demo').style.display = "none";
	document.getElementById('fadeIn-demo').style.opacity = "0";
	document.getElementById('fadeIn-demo').style.zIndex = "-1";
	slideDemo('slideToggle');
	slideDemo('slideUp');
	slideDemo('slideDown');
	fadeDemo('fadeIn');
	fadeDemo('fadeOut');
});

function slideDemo(name)
{
	const el = document.getElementById(`${name}-demo`);
	const action = document.getElementById(`${name}-demo-action`);
	action.addEventListener('click', ()=>{
		rwxSlide[name](el, 1, ()=>{console.log("done")});
	});	
}

function fadeDemo(name)
{
	const el = document.getElementById(`${name}-demo`);
	const action = document.getElementById(`${name}-demo-action`);
	action.addEventListener('click', ()=>{
		rwxFade[name](el);
	})
}